module.exports = __webpack_public_path__ + "img/video-productionMob.f991fb28.jpg";